import { mapActions } from 'vuex';

const ControlMixin = {
  props: {
    actors: {
      type: Array,
      required: true,
    },
    vars: {
      type: Array,
      required: true,
    },
    defaultValue: {
      required: false,
    },
  },
  computed: {
    getVar() {
      return this.vars[0];
    },
    getActor() {
      return this.actors[0];
    },
  },
  methods: {
    ...mapActions([
      'setVarsValue',
    ]),
    setVarsToValue(vars, value) {
      vars.forEach((varItem) => {
        this.setVarsValue({ varItem, value });
      });
    },
  },
};

export default ControlMixin;
